import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Notice, signalVariants, Stack, Text, textVariants, vars } from '@etg/wings';
import { useOrderDetails } from '../../containers/OrderDetailsContext';
import RefundStatusCases from './RefundStatusCases';
import RefundedAmount from './RefundedAmount';

const noticeDescriptionStyles = css`
  margin-inline-start: 28px;
`;

const noticeTitleStyles = css`
  color: ${vars.colors.text};
`;

const RefundStatus = () => {
  const { t } = useTranslation();
  const { refundStatus } = useOrderDetails();

  return (
    <>
      {refundStatus!!.hasChargeback ? (
        <Stack data-testid="refund-status-chargeback-message" spacing={0}>
          <Notice variant={signalVariants.CRITICAL}>
            <Text className={noticeTitleStyles} variant={textVariants._14_BOLD}>
              {t('MyBookings.RefundStatus.Chargeback.Title')}
            </Text>
          </Notice>
          <Text asHtml className={noticeDescriptionStyles}>
            {t('MyBookings.RefundStatus.Chargeback.Description')}
          </Text>
        </Stack>
      ) : (
        <Stack>
          <RefundStatusCases cases={refundStatus!!.cases} />
          {refundStatus!!.refundedCasesTotalAmount && (
            <RefundedAmount
              cases={refundStatus!!.cases}
              totalRefundedAmount={refundStatus!!.refundedCasesTotalAmount}
            />
          )}
        </Stack>
      )}
    </>
  );
};

export default RefundStatus;
